import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

// A searchable single-select for the site form's country field. On change,
// looks up the country's ISO 3166-1 alpha-2 / alpha-3 codes from
// data-country-picker-codes-value and reflects them into the code targets
// (visible caption + optional hidden inputs so a downstream form can
// receive them). Also runs on connect so the codes are populated for a
// pre-selected country in the edit form.
//
// Values:
//   codes: { "Nigeria": { iso2: "NG", iso3: "NGA" }, ... }
//
// Targets:
//   select: the underlying <select> (Choices wraps it)
//   iso2:   optional element whose textContent (or .value, for inputs) is
//           set to the selected country's ISO2 code
//   iso3:   same, ISO3
export default class extends Controller {
  static targets  = ["select", "iso2", "iso3"];
  static values   = { codes: Object };

  connect() {
    if (this.selectTarget.dataset.choicesInitialized === "true") {
      this.update();
      return;
    }
    this.selectTarget.dataset.choicesInitialized = "true";

    this.choices = new Choices(this.selectTarget, {
      allowHTML: true,
      searchEnabled: true,
      searchResultLimit: 20,
      shouldSort: false,
      itemSelectText: "",
      // Single-select — no "remove" pill.
      removeItemButton: false,
    });

    this.selectTarget.addEventListener("change", () => this.update());
    this.update();
  }

  disconnect() {
    if (this.choices) {
      this.choices.destroy();
      this.choices = null;
    }
  }

  update() {
    const name  = this.selectTarget.value;
    const entry = (this.codesValue && this.codesValue[name]) || {};
    this._set(this.hasIso2Target ? this.iso2Target : null, entry.iso2 || "");
    this._set(this.hasIso3Target ? this.iso3Target : null, entry.iso3 || "");
  }

  _set(el, value) {
    if (!el) return;
    if ("value" in el && el.tagName === "INPUT") el.value = value;
    else el.textContent = value;
  }
}
